import type { ReactNode } from "react"
import React from "react"
import { PiInfo } from "react-icons/pi"

import type { IconButtonProps, StackProps } from "@chakra-ui/react"
import {
  Box,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Portal,
  Stack,
} from "@chakra-ui/react"

type InfoPopoverProps = Omit<StackProps, "content"> & {
  content: ReactNode
  children?: ReactNode
  iconProps?: Partial<IconButtonProps>
}

export const InfoPopover = ({
  content,
  children,
  iconProps,
  ...props
}: InfoPopoverProps) => {
  return (
    <Popover trigger="hover" closeDelay={500}>
      <Stack direction="row" align="center" spacing={0} {...props}>
        {children && <Box>{children}</Box>}

        <PopoverTrigger>
          <IconButton
            variant="ghost"
            colorScheme="secondary"
            size="xs"
            icon={<PiInfo fontSize={16} />}
            aria-label="More information"
            {...iconProps}
          />
        </PopoverTrigger>
      </Stack>

      <Portal>
        <PopoverContent>
          <PopoverArrow />

          <PopoverBody color="neutrals.900">{content}</PopoverBody>
        </PopoverContent>
      </Portal>
    </Popover>
  )
}
